// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WBMSelectedAddress } from "wbm-selected-address";

export default WBMSelectedAddress;
